export default class Task {
  id: number;
  name: string;
  projectName: string;
  projectId: number;
  companyId: number;

  static fromJSON(o: Object): Task {
    const task = new Task();
    task.id = o["id"];
    task.name = o["name"];
    task.projectName = o["project_id"][1] || "";
    task.projectId = o["project_id"][0] || 0;
    task.companyId = o["company_id"];
    return task;
  }
}
